/**
 * Component (storyblok)
 * TODO: keep this until both sites share same components folder.
 * Shared component between the sites.
 * Used to prevent confusion while editing components.
 */
const Spacing = require("../../../../components/src/components/utils/spacing");
module.exports = Spacing;
